/** Fired when medical records change (teacher submit or admin approve/reject/etc.) — refresh sidebar/dashboard counts */
export const MEDICAL_RECORDS_CHANGED_EVENT = 'medical-records-changed'

export function notifyMedicalRecordsChanged(): void {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent(MEDICAL_RECORDS_CHANGED_EVENT))
}
